import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_cloud",
  "use": "icon-project_cloud-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_cloud\"><path d=\"M21.434 23l.425-.06A6.001 6.001 0 0027 17c0-3.314-2.686-6-5.977-6l-.986.022-.166-.82a6.5 6.5 0 00-12.856 1.734l.068 1.067L6.013 13H6a5 5 0 000 10h15.434z\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol